const DASHBOARD_REACT_BASE = '/dashboard-react';
const DASHBOARD_BASE = '/dashboard';

export function getDashboardBasePath(pathname = '') {
  const path = String(pathname || '');
  if (path === DASHBOARD_REACT_BASE || path.startsWith(`${DASHBOARD_REACT_BASE}/`)) {
    return DASHBOARD_REACT_BASE;
  }
  return DASHBOARD_BASE;
}

export function getCurrentDashboardBasePath() {
  if (typeof window === 'undefined') return DASHBOARD_BASE;
  return getDashboardBasePath(window.location.pathname);
}
